import React, {Component} from 'react';
import {connect} from 'react-redux';
import {showPopup} from 'helpers/modal';

class PopupOpener extends Component {
    onClick() {
        const {component} = this.props;

        this.props.dispatch(
            showPopup(component, {
                useConfirm: false,
                useClose: true,
                type: 'details',
            }),
        );
    }
    render() {
        const {className = '', tooltipText, children = null} = this.props;

        return (
            <button
                type="button"
                className={`exchange-opener ${className}`}
                {...(tooltipText && {'data-tooltip-html': tooltipText})}
                onClick={this.onClick.bind(this)}
            >
                {children}
            </button>
        );
    }
}

export default connect(() => ({}))(PopupOpener);
